import type { CommandeDetail } from '../../api/types';
import { truncateMaquettes } from '../../lib/format';
import { Section } from '../ui';

/** What the app would receive right now (preview.detail / preview.statut), always expanded. */
export default function ApercuApp({ preview }: { preview: CommandeDetail['preview'] }) {
  return (
    <Section title="Aperçu app">
      <p className="text-xs text-outline">
        <code className="font-mono">preview.detail</code> = réponse de WalletDetailCommande maintenant ;{' '}
        <code className="font-mono">preview.statut</code> = réponse de WalletStatutBillet. Les maquettes sont tronquées.
      </p>
      <div className="mt-3 grid gap-3 lg:grid-cols-2">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-outline">preview.detail</p>
          <pre className="mt-1 max-h-96 overflow-auto rounded-lg border border-card-border bg-surface-inset p-3 font-mono text-xs text-on-surface-variant">
            {JSON.stringify(truncateMaquettes(preview.detail), null, 2)}
          </pre>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-outline">preview.statut</p>
          <pre className="mt-1 max-h-96 overflow-auto rounded-lg border border-card-border bg-surface-inset p-3 font-mono text-xs text-on-surface-variant">
            {JSON.stringify(preview.statut, null, 2)}
          </pre>
        </div>
      </div>
    </Section>
  );
}
